module.exports = __webpack_public_path__ + "assets-wl/images/powered_banner.png?63fe5be0";